import axios from 'axios';
import config from '../config/env';
import tokenManager from './tokenManager';

// Configuración base de Axios usando la configuración de entorno
const axiosInstance = axios.create({
  baseURL: config.API_BASE_URL,
  timeout: config.API_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Interceptor para requests
axiosInstance.interceptors.request.use(
  async (config) => {
    if (tokenManager.requiresAuth(config.url)) {
      try {
        const token = await tokenManager.getValidToken();
        
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (error) {
        console.error('❌ Error obtaining token for request:', error);
      }
    }
    // Log de requests en desarrollo
    if (process.env.NODE_ENV === 'development') {
      console.log('🚀 API Request:', {
        method: config.method?.toUpperCase(),
        url: config.url,
        data: config.data,
      });
    }
    return config;
  },
  (error) => {
    console.error('❌ Request Error:', error);
    return Promise.reject(error);
  }
);

// Interceptor para responses
axiosInstance.interceptors.response.use(
  (response) => {
    // Log de responses en desarrollo
    if (process.env.NODE_ENV === 'development') {
      console.log('✅ API Response:', {
        status: response.status,
        url: response.config.url,
        data: response.data,
      });
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    
    // Manejar 401: token expirado o inválido
    if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true;
      
      try {
        tokenManager.clearToken();
        const newToken = await tokenManager.getValidToken();
        
        if (newToken) {
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return axiosInstance(originalRequest);
        }
      } catch (refreshError) {
        console.error('❌ Error refreshing token:', refreshError);
        return Promise.reject(error);
      }
    }
    // Log de errores
    console.error('❌ API Error:', {
      status: error.response?.status,
      url: error.config?.url,
      message: error.message,
      data: error.response?.data,
    });
    
    // Manejo de errores específicos
    if (error.response?.status === 401) {
      console.warn('🔐 Unauthorized - Token may be expired');
    } else if (error.response?.status === 403) {
      console.warn('🚫 Forbidden - Insufficient permissions');
    } else if (error.response?.status >= 500) {
      console.error('🔥 Server Error - API is down');
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;
























